<script>
		import { user, view } from "../client.svelte.js"
		import {calc_defaultCS, notEmpty, token_URL} from "../core.js";
		import Input from "./Input.svelte"
		import Select from "./Select.svelte";
		import Output from "./Output.svelte";

		let { data: character, mode = 'edit', onselect, onaction = {}} = $props();
		let affil = $derived((character.affiliation === "enemy" && typeof character.rank === 'number') ? `rank${character.rank}` : character.affiliation)
		let callsign = $state((character) ? character.CS ?? calc_defaultCS(character.name ?? "") : "")
		let disabled = $derived(character.ZUB !== 'Variant')
		let fallback = false


		function pickup_token(e) {
				view.dragParams = {typ: mode, ID: character.ID, level: character.level, ondrop: onaction['deploy']}
				e.dataTransfer.setData('char/ID', character.ID)
				e.dataTransfer.effectAllowed = 'copy'
				e.dataTransfer.setDragImage(e.target, 25, 25) // (e.target.firstElementChild, 10, 10)
		}
</script>


<!------------------------------- HTML ------------------------------------->

<div class="card {character.ZUB ?? character.TYPE}" onclick={onselect.bind(character)} >
	<figure class="icon spanRows" draggable=true title={character.descript} ondragstart={pickup_token} onclick={onselect.bind(character)} >
    <div class="affiliation {affil}"></div>
			<img src={character.tokenURL} alt={character.ID} title={character.ID} />
      <figcaption>{character.callsign ?? ""}</figcaption>
	</figure>
	<Output field=name value={character.name} class="triplespan" />
	<Output field=level value={character.level} type='number' />
	{#if mode !== 'deploy'}
		<Output field=combat value={(character.combat) ? character.combat : ''} type=number />
		<Output field=ranged value={character.profics?.bow ?? character.profics?.arba ?? ""} type=number />
		<Output field=magic value={(character.magic) ? character.magic : ''} type=number />
	{:else}
		<Output field='callsign' value={callsign} style="text-align: center;"/>
		<Output field=affil value={character.affiliation} class="doublespan"/>
	{/if}
	<Output field=LP value={character.vital} type='number' />
</div>


<!------------------------------- STYLES ------------------------------------->

<style lang="sass">
	.card
		position: relative
		width: 280px
		margin:  4px
		padding: 4px
		border: 2px solid black
		display: grid
		grid-template-columns: 64px repeat(4, 1fr)
		row-gap: unset

	.Character
		background-color: #222

	.Variant
		background-color: #111

	.CharacterSnippet
		background-color: #000

	.icon
		justify-self: center
		align-self: center

		figcaption
			top: 48px
			width: 5ch

	figure img
		pointer-events: auto
		width: 	64px
		height: 64px

	.appear-attribs
		grid-column: 1 / span 5
		margin: 8px
		display: grid
		grid-template-columns: 8ch 1fr 8ch 2fr

</style>